import { createApp, configureCompat } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import setting from './config/website'
import ElementUI from 'element-plus'
import './design/index.scss'
import 'animate.css'
import 'element-plus/dist/index.css'
import 'swiper/swiper-bundle.css'
import 'wow.js/css/libs/animate.css'
import './design/iconfont.css'
import './design/elementUI.scss'
import './design/font.scss'

const app = createApp(App)

configureCompat({
  MODE: 3,
})

app.use(store)
app.use(router)
app.use(ElementUI)

app.config.globalProperties.$prefix = setting.prefix
app.mount('#app')
